/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import * as d3 from 'd3';

export interface DonutChartConfig {
  height: number;
  width: number;
  margin: number;
  radius: number;
  thickness: number;
  grow: number;
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-strategy-donut-chart',
  styleUrls: ['./strategy-donut-chart.component.scss'],
  templateUrl: './strategy-donut-chart.component.html',
  standalone: false
})
export class StrategyDonutChartComponent implements OnInit, OnChanges {
  @Input() selected: number | null = null;
  @Input() config: DonutChartConfig;
  @Input() data = [];
  @Output() updateSelected = new EventEmitter<number | null>();

  // D3 utils
  slices: any;
  g: any;
  color: any;
  pie = d3
    .pie()
    .value((d: any) => d.value)
    .sort(null);

  arc: any;
  arcOver: any;

  ngOnInit(): void {
    this.arc = d3
      .arc()
      .innerRadius(this.config.radius - this.config.thickness)
      .outerRadius(this.config.radius);

    this.arcOver = d3
      .arc()
      .outerRadius(this.config.radius + this.config.grow)
      .innerRadius(this.config.radius - this.config.thickness);

    this.drawChart(this.data);
  }

  drawChart(data): void {
    const svg = d3.select('#donut-chart');

    svg
      .attr('width', this.config.width + this.config.margin + this.config.margin)
      .attr('height', this.config.height + this.config.margin + this.config.margin);

    this.g = svg
      .append('g')
      .attr('transform', 'translate(' + (this.config.width / 2 + this.config.margin) + ',' + (this.config.height / 2 + this.config.margin) + ')');

    svg.node();

    this.updateData(data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.data && !changes?.data?.firstChange) {
      this.updateData(changes.data.currentValue);
    }

    if (changes?.selected) {
      const index = changes.selected.currentValue !== null ? changes.selected.currentValue : null;
      this.handleSelection(index as number);
    }
  }

  updateData(data): void {
    this.slices = this.g.selectAll('g').remove();

    this.slices = this.g.selectAll('.part').data(this.pie(data)).enter().append('g');

    this.slices
      .append('path')
      .attr('d', this.arc)
      .attr('class', 'slices')
      .attr('fill', (d) => d.data.color)
      .style('cursor', 'pointer');

    this.slices.on('click', (event, item) => {
      this.updateSelected.emit(item.data.id as number);
    });

    this.slices.on('mouseover', (event, slice) => {
      d3.selectAll('.slices')
        .filter((item: any) => item.data.id === slice.index)
        .transition()
        .duration(200)
        .attr('d', this.arcOver);
    });

    this.slices.on('mouseout', (event, slice) => {
      d3.selectAll('.slices')
        .filter((item: any) => item.data.id === slice.index)
        .transition()
        .duration(100)
        .attr('d', this.arc);
    });
  }

  private handleSelection(index: number | null): void {
    if (index === null) {
      d3.selectAll('.slices').transition().duration(300).style('opacity', '1');
      return;
    }

    d3.selectAll('.slices').style('opacity', '0.3');

    d3.selectAll('.slices')
      .filter((item: any) => item.data.id === index)
      .style('opacity', '1');
  }
}
